import { loadMessages } from './loadMessages';
import { LocalizationProvider } from './LocalizationProvider';
import { LocalizationService } from './LocalizationService';
export { loadMessages, LocalizationProvider, LocalizationService };
// Automatic installation if Vue has been added to the global scope.
var vue = 'Vue';
if (typeof window !== 'undefined' && window[vue] && window[vue].component) {
    window[vue].component('kendo-localization-provider', LocalizationProvider);
}



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-intl/dist/es/Localization/main.js
// module id = 852
// module chunks = 93